export const modalStyle = {
  width: { xs: "95%", sm: "80%" },
  maxWidth: "1000px",
  color: "white",
  borderRadius: "4px",
};

export const ContactModalSx = {
  display: "flex",
  flexWrap: "wrap",
  gap: "20px",
  justifyContent: "center",
};
export const WrapperBoxSx = {
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  width: "100%",
};

export const ContactModalitemSx = {
  width: { xs: "100%", sm: "450px" },
  minHeight: "180px",
  backgroundColor: "#070707",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  gap: "20px",
  p: 2,
};

export const PhoneTiposx = {
  fontSize: "24px",
  fontWeight: 600,
  lineHeight: "36px",
  color: "#FFFFFF",
};

export const InformationSx = {
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "24px",
  color: "#C7C7C7",
};
